



























































import {
	defineComponent,
	PropType,
} from '@vue/composition-api';
import FormError from '@front-app/components/form/FormError.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import BasicTextEditor from '@front-app/components/inputs/BasicTextEditor.vue';

export default defineComponent({
	components: {
		BasicTextEditor,
		FormError,
		FormLabel,
		FormSection,
	},
	props: {
		value: {
			type: String,
			required: true,
		},
		label: {
			type: String,
			required: true,
		},
		noEmailAddressesError: Boolean,
		invalidEmails: {
			type: Array as PropType<string[]>,
			required: false,
			default: () => [],
		},
		duplicateEmails: {
			type: Array as PropType<string[]>,
			required: false,
			default: () => [],
		},
	},
	setup() {
		return {};
	},
});
